<script setup>
const callsToAction = [
  { name: 'info@dexon-technology.com', href: 'mailto:info@dexon-technology.com', icon: 'email' },
  { name: '+66 (0) 33-012484-7', href: 'tel:+66330124847', icon: 'phone' },
]
</script>

<template>
  <div>
    <div class="header-sm relative inset-x-0 hidden lg:flex">
      <nav class="flex items-center py-2.5 container">
        <div class="flex">
          <a v-for="item in callsToAction" :key="item.name" :href="item.href" class="flex items-center pr-3 text-sm">
            <div class="flex text-xl leading-5" aria-hidden="true">
              <svg v-if="item.icon === 'phone'" class="mr-2 text-secondary-red-100" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.95 21q-3.225 0-6.287-1.425t-5.425-3.8q-2.363-2.375-3.8-5.438T3 4.05v-.525Q3 3.25 3.05 3H8.9l.925 5.025l-2.85 2.875q1.05 1.8 2.638 3.375T13.1 17l2.9-2.9l5 1v5.85q-.25.025-.525.038T19.95 21ZM6.025 9l1.65-1.65L7.25 5H5.025q.125 1.025.35 2.025T6.025 9Zm8.95 8.95q.975.425 1.988.675T19 18.95v-2.2l-2.35-.475l-1.675 1.675ZM6.025 9Zm8.95 8.95Z" /></svg>
              <svg v-if="item.icon === 'email'" class="mr-2 text-secondary-red-100" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5l8-5v10zm-8-7L4 6h16l-8 5z" /></svg>
            </div>
            <span class="text-sm font-medium text-white">{{ item.name }}</span>
          </a>
          <!-- <DarkToggle /> -->
        </div>
        <div class="flex flex-1 items-center justify-end gap-x-2.5">
          <UISearchBar expanded />
          <NuxtLink
            :to="localePath({ path: '/career-at-dexon' })"
            class="btn-primary bg-white font-bold text-secondary-red-100 shadow-custom-md"
          >
            {{ $t('button.career') }}
          </NuxtLink>
          <NuxtLink :to="localePath({ path: '/contact-us' })" class="btn-primary bg-red-gradient font-bold text-white shadow-custom-md">
            {{ $t('button.quote') }}
          </NuxtLink>
        </div>
      </nav>
    </div>
  </div>
</template>
